var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFutureBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "55px",
    viewBox: "0 0 90 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "21D82ECD-EDC7-4067-86F3-B82582B62202@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skipped-Box-States",
    transform: "translate(-457.000000, -351.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-order-b",
    transform: "translate(457.000000, 351.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "0.692307692 8.01098901 11.2747253 1.58241758 85.9450549 1.18681319 88.8131868 3.36263736 88.6153846 46.978022 87.5274725 50.043956 76.7472527 54.3956044"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 1,
    y: 6,
    width: 77.6373626,
    height: 47.6703297
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1758242,0.89010989 L0.593406593,5.93406593 L0.0989010989,6.13186813 L0.0989010989,54.8901099 L78.7252747,54.7912088 L78.9230769,54.6923077 L89.5054945,49.6483516 L89.5054945,0.89010989 L11.1758242,0.89010989 Z M11.3736264,2.17582418 L86.1428571,2.17582418 L78.1318681,6.03296703 L3.46153846,6.03296703 L11.3736264,2.17582418 Z M77.7362637,53.7032967 L1.28571429,53.7032967 L1.28571429,7.21978022 L77.6373626,7.21978022 L77.6373626,53.7032967 L77.7362637,53.7032967 Z M78.9230769,53.3076923 L78.9230769,7.02197802 L88.2197802,2.57142857 L88.2197802,48.956044 L78.9230769,53.3076923 Z",
    id: "Shape",
    fill: "#231F20",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutureBox);
export default __webpack_public_path__ + "static/media/future-box.52c21d1be2040343d55152e3c330edd8.svg";
export { ForwardRef as ReactComponent };